/**
 * @file OpenTelemetry HTTP Response Metrics Handler
 * @description Handles the recording of OpenTelemetry metrics for HTTP responses.
 */

import { httpRequestDuration, httpResponseSize, httpStatusCodeCounter } from '../metrics';
import { buildHttpResponseMetricAttributes } from './httpRequestsMetricAttributes';

/**
 * Handles the recording of OpenTelemetry metrics for an HTTP response.
 *
 * @param {Object} params - The HTTP response parameters.
 * @param {string} params.method - The HTTP method (GET, POST, etc.).
 * @param {string} params.url - The URL of the HTTP request.
 * @param {number} params.duration - The timestamp of the request duration.
 * @param {number} params.status - The HTTP response status code.
 * @param {number} [params.dataSizeInBytes] - The response data size.
 */
export const otlHandleHttpResponseMetrics = ({ method, url, duration, status, dataSizeInBytes }) => {
    const requestAttributes = buildHttpResponseMetricAttributes(url, method, status);
    // Record the duration of the request
    httpRequestDuration.record(duration, requestAttributes);
    // Increase HTTP status counter
    httpStatusCodeCounter.add(1, requestAttributes);
    if (dataSizeInBytes) {
        // Record the size of the response
        httpResponseSize.record(dataSizeInBytes, requestAttributes);
    }
};
